import { Box, Typography } from '@mui/material'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium'
import { isDefined } from '@omnea-app/legacy/utils/type-guard/isDefined'
import { BaseColumnConfig } from '../types'
import { baseColumnConfig } from './baseColumnConfig'
import { HoverLinkWrapper } from './helpers/HoverLinkWrapper'
import type { GridValidRowModel } from '@mui/x-data-grid/models/gridRows'

export type AgreementColumnConfig<T extends GridValidRowModel> = BaseColumnConfig<T, 'agreement'> & {
  columnType: 'agreement'
  showPublicId?: boolean
}

export const getAgreementColumn = <T extends GridValidRowModel>({
  style,
  showPublicId,
  ...config
}: AgreementColumnConfig<T>): GridColDef<T> => ({
  ...baseColumnConfig,
  ...style,
  ...config,
  valueGetter: (_, row) => row.agreement?.name,
  renderCell: (params: GridRenderCellParams<T>) => {
    if (!isDefined(params.value)) return null
    const agreementId = params.row.agreement?.id
    if (!isDefined(agreementId)) return null
    const publicId = params.row.agreement?.publicId
    const label = showPublicId && isDefined(publicId) ? `${params.value} (${publicId})` : params.value
    const href = `/agreements/detail/${agreementId}`

    return (
      <Box
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          window.open(href, '_blank', 'noopener,noreferrer')
        }}
        sx={{ display: 'block', color: 'inherit', textDecoration: 'none' }}
      >
        <HoverLinkWrapper>
          <Typography variant="Body14pxRegular" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {label}
          </Typography>
        </HoverLinkWrapper>
      </Box>
    )
  },
})
